export enum FilterOptionTypes {
  // CATEGORIES = "categories",
  // BRANDs = "brands",
  // RATING = "rating",
  // PRICE = "price",
  // RADIO = "radio",
  VALUES = "values",
  VARIANTS = "variants",
  MINIMUM = "minimum",
  RANGE = "range",
}

export enum FilterOptionInputType {
  VALUES = "values",
  VARIANT = "variants",
  RANGE = "range",
}

export interface FilterValue {
  key?: string,
  count?: number,
  value?: string,
  from?: number| "*",
  to?: number | "*"
}


export interface Filter {
  key?:    string;
  label?:  string;
  type?:   FilterOptionTypes;
  values?: FilterValue[];
  max?:    number;
  min?:    number;
}
